import React from 'react'
import Button from '@UI/antd/Button/Button'
import Stepper from '@components/Stepper'
import LogoutBoxLineIcon from 'remixicon-react/LogoutBoxLineIcon'
import XArrowIcon from '@UI/XArrowIcon'
import styles from './index.scss'
import Form from 'antd/lib/form'

interface IEventDetailsFooterDesktop {
    hasSkip: boolean
    loading: boolean
    activeStep: number
    onNext: () => any
    onBack: () => any
    onLeave: () => any
    onSkip: () => any
    i18n?: any
    stepKey?: string
}

function EventDetailsFooterDesktop(props: IEventDetailsFooterDesktop) {
    const { onNext, onBack, onLeave, onSkip, hasSkip, activeStep, loading = false, i18n, stepKey } = props
    const stepArray = [
        { title: i18n?.Event?.Event_Details || 'Event Details', route: '/organizer/events/details' },
        { title: i18n?.General?.Branding || 'Branding', route: '/organizer/events/branding' },
        { title: i18n?.Event?.['Import Attendees'] || 'Import Attendees', route: '/organizer/events/import' },
        { title: i18n?.General?.Categories || 'Categories', route: '/organizer/events/category' },
        { title: i18n?.General?.Publish || 'Publish', route: '/organizer/events/successful' }
    ]

    return (
        <div className={styles['event-details-footer']}>
            <Button typeButton="secondary-outlined" icon={<LogoutBoxLineIcon />} onClick={onLeave}>
                {i18n?.General?.Leave}
            </Button>
            <Stepper absoluteStyleContainer current={activeStep} steps={stepArray} />
            <div className={styles['event-details-footer__rctrl']}>
                {hasSkip && (
                    <Button typeButton="secondary-ghost" onClick={onSkip}>
                        {i18n?.extraKeys?.Skip}
                    </Button>
                )}
                <Button
                    typeButton="secondary-outlined"
                    style={{ minWidth: 40 }}
                    icon={<XArrowIcon />}
                    onClick={onBack}
                />
                <Form.Item>
                    <Button
                        typeButton="primary-solid"
                        htmlType="submit"
                        icon={<XArrowIcon reverse />}
                        onClick={onNext}
                        disabled={loading}
                        loading={loading}
                        id={`submit-${stepKey}`}
                    >
                        {i18n?.General?.Continue}
                    </Button>
                </Form.Item>
            </div>
        </div>
    )
}

export default EventDetailsFooterDesktop
